<template>
  <div class="content">
    <div class="row mt-0">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <h4 slot="header" class="card-title text-left">
            ANIVERSARIANTES DO MÊS
          </h4>
          <div v-show="tela == 1">
            <div class="row p-1">
              <div class="col-sm-12 text-left mt-1">
                <div class="d-flex">
                  <div class="mr-3 form-group text-left has-label">
                    <label>
                      Mês
                    </label>
                    <el-select
                      class="select-success pagination-select"
                      placeholder=""
                      v-model="mes"
                    >
                      <el-option
                        v-for="item in meses"
                        :key="item.id"
                        class="select-success"
                        :label="item.nome"
                        :value="item.id"
                        >{{ item.nome }}</el-option
                      >
                    </el-select>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-12 text-center mt-1 row">
              <base-button
                type="success"
                class="btn_ text-center col-sm-3 col-12 animation-on-hover"
                @click="pesquisar()"
                >Pesquisar</base-button
              >
            </div>
          </div>
          <div class="row pl-4 pr-4" v-show="tela == 2" id="imprimirFolha">
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <div class="col-6 d-flex justify-content-start hidden-print">
                <base-button
                  v-show="!printing"
                  type="info"
                  class="animation-on-hover"
                  @click="tela = 1"
                  ><i class="tim-icons icon-minimal-left"></i>
                  Voltar</base-button
                >
              </div>
              <div class="col-6 d-flex justify-content-end hidden-print">
                <base-button
                  v-show="!printing"
                  type="info"
                  class="animation-on-hover"
                  @click="imprimirFolha()"
                  simple
                >
                  <i class="tim-icons icon-paper"></i> Imprimir
                </base-button>
              </div>
            </div>
            <!--Cabecalho-->
            <div class="container p-3 rounded" style="background: #f9f9f9;">
              <div class="row">
                <div class="col-6">
                  <div class="row">
                    <div class="col text-left">
                      MÊS ESCOLHIDO: {{ pegarTitulo() }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col text-left">
                      {{
                        `RELATÓRIO GERADO EM: ${moment().format(
                          "DD/MM/YYYY HH:mm",
                        )}`
                      }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--Tabela de Resultados-->
            <div class="table-responsive p-3">
              <table class="table table-hover table-bordered">
                <thead>
                  <tr>
                    <th scope="col"></th>
                    <th scope="col">Nome</th>
                    <th scope="col">Dia</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in dados" :key="`${item.data}-${item.nome}`">
                    <th>
                      <p class="m-0 p-0">
                        <i class="tim-icons icon-gift-2"></i>
                      </p>
                    </th>
                    <th>
                      <p class="m-0 p-0">{{ item.nome }}</p>
                    </th>
                    <th>
                      <p class="m-0 p-0">
                        {{ moment(item.data_nascimento).format("DD/MM") }}
                      </p>
                    </th>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </card>
      </div>
    </div>

    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        loader="spinner"
        color="#35a887"
        :is-full-page="true"
      >
      </loading>
    </div>
  </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { Card } from "@/components/index";
import { Table, TableColumn, Select, Option } from "element-ui";
import moment from "moment";
import swal from "sweetalert2";

export default {
  components: {
    Card,
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  computed: {},
  data() {
    return {
      isLoading: false,
      meses: [
        {
          id: 1,
          nome: "Janeiro",
        },
        {
          id: 2,
          nome: "Fevereiro",
        },
        {
          id: 3,
          nome: "Março",
        },
        {
          id: 4,
          nome: "Abril",
        },
        {
          id: 5,
          nome: "Maio",
        },
        {
          id: 6,
          nome: "Junho",
        },
        {
          id: 7,
          nome: "Julho",
        },
        {
          id: 8,
          nome: "Agosto",
        },
        {
          id: 9,
          nome: "Setembro",
        },
        {
          id: 10,
          nome: "Outubro",
        },
        {
          id: 11,
          nome: "Novembro",
        },
        {
          id: 12,
          nome: "Dezembro",
        },
      ],
      mes: 1,
      dados: [],
      payloadPesquisa: {},
      tela: 1,
      printing: false,
    };
  },
  created() {},
  beforeUnmount() {
    this.disconectarSocket();
  },
  mounted() {},
  methods: {
    imprimirFolha() {
      this.printing = true;
      this.isLoading = true;

      try {
        this.$nextTick(() => {
          this.$htmlToPaper("imprimirFolha", null, () => {
            this.printing = false;
            this.isLoading = false;
          });
        });
      } catch (error) {
        console.error("Erro ao imprimir a folha:", error);
        this.isLoading = false;
        this.printing = false;
      }
    },
    showSwal(type, title, text, typeMsg) {
      if (type === "auto-close") {
        swal({
          title: title,
          text: text,
          type: typeMsg,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    },
    moment: function(data) {
      return moment(data);
    },
    pesquisar() {
      this.isLoading = true;
      const payload = { setDB: this.$cookies.get("db"), mes: this.mes };
      this.payloadPesquisa = payload;
      this.carregarRelatorio(payload);
    },
    carregarRelatorio(payload) {
      let th = this;
      th.isLoading = true;
      this.axios
        .post("/api/empregado/relatorioAniversariantes", payload, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          th.isLoading = false;
          if (response.data.status) {
            this.tela = 2;
            this.dados = response.data.data.dados;
          } else {
            th.showSwal(
              "auto-close",
              "Erro",
              "Erro ao solicitar relatório!",
              "error",
            );
          }
        })
        .catch((err) => {
          th.isLoading = false;
          console.log(err);
          th.showSwal(
            "auto-close",
            "Erro",
            "Erro ao solicitar relatório!",
            "error",
          );
        });
    },
    pegarTitulo() {
      return this.meses.find((mes) => mes.id === this.mes).nome;
    },
  },
  watch: {},
};
</script>
<style></style>
